import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Link = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M20.412 5.81265C18.6546 4.05529 15.8054 4.05529 14.048 5.81265L13.6944 6.1662L15.1087 7.58042L15.4622 7.22686C16.4385 6.25055 18.0214 6.25055 18.9977 7.22686C19.9741 8.20317 19.9741 9.78609 18.9977 10.7624L14.755 15.0051C13.7788 15.9814 12.1959 15.9814 11.2196 15.0051C10.2433 14.0288 10.2434 12.4459 11.2197 11.4696L11.9268 10.7626L10.5127 9.34832L9.8056 10.0553C8.04811 11.8126 8.04804 14.6619 9.80543 16.4193C11.5627 18.1766 14.4119 18.1766 16.1693 16.4193L20.412 12.1766C22.1693 10.4193 22.1693 7.57001 20.412 5.81265Z"
      fill="currentColor"
    />
    <path
      d="M3.08779 18.1873C4.84515 19.9446 7.6944 19.9446 9.45176 18.1873L9.80531 17.8337L8.3911 16.4195L8.03754 16.7731C7.06123 17.7494 5.47832 17.7494 4.50201 16.7731C3.5257 15.7967 3.5257 14.2138 4.50201 13.2375L8.74465 8.99488C9.72096 8.01857 11.3039 8.01857 12.2802 8.99488C13.2565 9.97119 13.2565 11.5541 12.2802 12.5304L11.5731 13.2375L12.9873 14.6517L13.6944 13.9446C15.4518 12.1873 15.4518 9.33803 13.6944 7.58067C11.937 5.82331 9.0878 5.82331 7.33044 7.58067L3.0878 11.8233C1.33044 13.5807 1.33044 16.4299 3.08779 18.1873Z"
      fill="currentColor"
    />
  </Icon>
));

export default Link;
